import type { ParamDef, ParamKind, ParamsSchema, ParamSchemaProp } from './types'

function kindOf(prop: ParamSchemaProp): ParamKind {
  switch (prop.type) {
    case 'integer':
      return 'int'
    case 'number':
      return 'float'
    case 'boolean':
      return 'bool'
    case 'string':
      return prop.enum && prop.enum.length > 0 ? 'choice' : 'str'
  }
}

/**
 * Turns a strategy's JSON-Schema `params_schema` into the ordered list of form
 * fields. Property order IS declaration order. A `null` schema (a strategy
 * whose strategy.toml failed to parse) yields no fields.
 */
export function schemaToParams(schema: ParamsSchema | null): ParamDef[] {
  if (schema === null) return []
  return Object.entries(schema.properties).map(([name, prop]) => ({
    name,
    kind: kindOf(prop),
    default: prop.default === undefined ? null : prop.default,
    help: prop.description ?? '',
    options: prop.enum ? [...prop.enum] : [],
  }))
}
